import { useState } from "react";
import SqcForm from "./SqcForm";
import SqcListview from "./SqcListview";

const SQC = () => {
  const [fromIsShown, setFromIsShown] = useState(false);
  const [upData, setUpData] = useState(false);
  const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
        <SqcForm addForm={setFromIsShown} update={upData}  sId={serviceId}/>
      ) : (
        <SqcListview addForm={setFromIsShown} update={setUpData}  sId={setServiceId}/>
      )}
    </>
  );
};

export default SQC;
